/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/assassination_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M17 16a1 1 0 11-2 0 1 1 0 112 0zm-.5-11.9V11h-1V4.1h1zM11 16.5H4.1v-1H11v1zm4.5 11.4V21h1v6.9h-1zM21 16.5v-1h6.9v1H21z"/>'
  }
})
